import Strings from "utils/strings"

import type { RouteExternalDeliveryBatch } from "../Routes/types"

/**
 * The route's own external delivery status — the lifecycle of a batch on
 * `route.externalDelivery.batches[]`. Derived from the route type so the two
 * can't drift apart.
 */
export type ExternalBatchingStatus = NonNullable<
	RouteExternalDeliveryBatch["status"]
>

export const BATCHING_STATUS_COLORS: Record<ExternalBatchingStatus, string> = {
	waiting_for_batching: "#8c8c8c",
	batched: "#1677ff",
	in_progress: "#fa8c16",
	completed: "#52c41a",
}

/** Every batching status, in lifecycle order. */
export const EXTERNAL_BATCHING_STATUS_VALUES = Object.keys(
	BATCHING_STATUS_COLORS
) as ExternalBatchingStatus[]

export function getBatchingStatusLabel(status?: string): string {
	if (!status) return "-"
	const labels: Record<string, string> = {
		waiting_for_batching: Strings.routes.externalBatchingProcessing,
		batched: Strings.routes.externalBatchingSearching,
		in_progress: Strings.routes.externalBatchingInProgress,
		completed: Strings.routes.externalBatchingCompleted,
	}
	return labels[status] || status
}
